import { all } from 'redux-saga/effects';
import authSaga from './modules/auth/authSaga';
import branchSaga from './modules/branch/saga';
import patientRegistrationSaga from './modules/admin/patientRegistartion/saga';
import patientInformationSaga from './modules/admin/patientInformation/saga';
import patientEmergencyContactSaga from './modules/admin/patientEmergencyContactInfo/saga';
import patientInsuranceSaga from './modules/admin/patientInsurance/saga';
import patientPhysicianSaga from './modules/admin/patientPhysician/saga';
import patientMedicalHistorySaga from './modules/admin/patientMedicalHistory/saga';
import patientLifeStyleSaga from './modules/admin/patientLifeStyle/saga';
import patientAcknowledgementSaga from './modules/admin/patientAcknowledgement/saga';
import patientProfileSaga from './modules/admin/patientProfile/saga';
import profileSaga from './modules/profile/saga';
import radiologySaga from './modules/radiology/saga';
import staffSaga from './modules/staff/saga';
import examSaga from './modules/exam/saga';
import verifySignatureSaga from './modules/verifySignature/saga';
import appointmentSaga from './modules/appoinment/saga';
import ordersSaga from './modules/orders/saga';
import reportSaga from './modules/report/saga';
import dashboardSaga from './modules/dashboard/saga';
import invoiceSaga from './modules/invoice/saga';
import voucherSaga from './modules/voucher/saga';
import analyticsSaga from './modules/analytics/saga';
import referralSaga from './modules/referral/saga';
import modalitySaga from './modules/modality/saga';
import homeSaga from './modules/home/saga';
import notificationSaga from './modules/notification/saga';
import patientsSaga from './modules/patients/saga';
import externalReferrerSaga from './modules/externalReferrer/saga';
import allStudiesSaga from './modules/allStudies/saga';
import reportTemplateSaga from './modules/reportTemplate/saga';
import labDepartmentSaga from './modules/laboratory/labDepartment/saga';
import labSpecimenTypeSaga from './modules/laboratory/labSpecimenType/saga';
import labTestSaga from './modules/laboratory/labTest/saga';
import labTestPanelSaga from './modules/laboratory/labTestPanel/saga';
import labOrderSaga from './modules/laboratory/labOrder/saga';
import labSpecimenSaga from './modules/laboratory/labSpecimen/saga';
import labResultSaga from './modules/laboratory/labResult/saga';
import labAnalyzerSaga from './modules/laboratory/labAnalyzer/saga';
import labQCSaga from './modules/laboratory/labQC/saga';
import labEquipmentSaga from './modules/laboratory/labEquipment/saga';
import labReagentSaga from './modules/laboratory/labReagent/saga';
import labReportSaga from './modules/laboratory/labReport/saga';
import labAnalyticsSaga from './modules/laboratory/labAnalytics/saga';
import labAlertSaga from './modules/laboratory/labAlert/saga';
import labUnmatchedResultSaga from './modules/laboratory/labUnmatchedResult/saga';
import permissionsSaga from './modules/permissions/saga';
import auditLogSaga from './modules/auditLog/saga';
import hospitalConfigSaga from './modules/hospitalConfig/saga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    branchSaga(),
    patientRegistrationSaga(),
    patientInformationSaga(),
    patientEmergencyContactSaga(),
    patientInsuranceSaga(),
    patientPhysicianSaga(),
    patientMedicalHistorySaga(),
    patientLifeStyleSaga(),
    patientAcknowledgementSaga(),
    patientProfileSaga(),
    profileSaga(),
    radiologySaga(),
    staffSaga(),
    examSaga(),
    verifySignatureSaga(),
    appointmentSaga(),
    ordersSaga(),
    reportSaga(),
    dashboardSaga(),
    invoiceSaga(),
    voucherSaga(),
    analyticsSaga(),
    referralSaga(),
    modalitySaga(),
    homeSaga(),
    notificationSaga(),
    patientsSaga(),
    externalReferrerSaga(),
    allStudiesSaga(),
    reportTemplateSaga(),
    labDepartmentSaga(),
    labSpecimenTypeSaga(),
    labTestSaga(),
    labTestPanelSaga(),
    labOrderSaga(),
    labSpecimenSaga(),
    labResultSaga(),
    labAnalyzerSaga(),
    labQCSaga(),
    labEquipmentSaga(),
    labReagentSaga(),
    labReportSaga(),
    labAnalyticsSaga(),
    labAlertSaga(),
    labUnmatchedResultSaga(),
    permissionsSaga(),
    auditLogSaga(),
    hospitalConfigSaga(),
  ]);
}